function cache(reusePromises = false) {
  return function(target, propertyKey, descriptor) {
    const original = descriptor.value;
    let cache2 = [];
    let interceptorId = 1;
    const newFunction = function(...args) {
      let instanceId = 0;
      if (!!this) {
        if (!this.__cache_interceptor) {
          this.__cache_interceptor = {
            id: interceptorId++,
            cache: []
          };
        }
        instanceId = this.__cache_interceptor.id;
        cache2 = this.__cache_interceptor.cache;
      }
      const signature = [instanceId, propertyKey].concat(args);
      const signatureKey = JSON.stringify(signature);
      let existingPromise = cache2[signatureKey];
      if (!existingPromise) {
        existingPromise = original.apply(this, args);
        cache2[signatureKey] = existingPromise;
        const removePromise = () => {
          if (!reusePromises) {
            delete cache2[signatureKey];
          }
        };
        existingPromise.then(removePromise).catch(removePromise);
      }
      return existingPromise;
    };
    descriptor.value = newFunction;
  };
}
export {
  cache
};
//# sourceMappingURL=PromiseCache.js.map
